<span class="mat-simple-snackbar-message">{{data.message}}</span>
<button id="{{data.action}}" mat-button class="mat-simple-snackbar-action" *ngIf="hasAction" (click)="dismiss()">
  {{data.action}}
</button>
